import { useUserUUID } from '@annunciate/core';
import { TAG_GET } from '@annunciate/query/dist/queries/tag';
import { useQuery } from './base';
export const useTagQuery = (id) => {
    const uuid = useUserUUID(true);
    const variables = { id };
    return useQuery(['tag', uuid], TAG_GET, variables, undefined, (data) => data.tag);
};
//# sourceMappingURL=useTagQuery.js.map